var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { BadRequestError } from '@lucidlink/sdk/fetcher';
import { InlineForm, TextInputField, translate, useModal, useToastService, } from '@lucidlink/uicore';
import { transformServerErrorsToInjectableErrors, useFormRoot, } from '@lucidlink/uicore/form-builder';
import { PII_MASK_CLASS } from '#constants';
import { filespaceNameValidator, workspaceRoutes } from '#services';
import { useFilespaceRename } from '../../../../../../query-hooks/mutations/useFilespaceRename';
import { filespaceNameValidationRules } from '../../../../../../services/validation/filespaceNameValidationRules';
import { FilespaceRenameAcknowledge } from '../../../../../FilespaceRenameAcknowledge';
import { filespaceRenameFormParser } from '../services/validation';
export const FilespaceRenameForm = ({ filespace }) => {
    _react_refresh_temp_2();
    const { closeModal, openModal } = useModal({
        closeOnUnmount: true,
    });
    const { formData, methods: { injectErrors }, } = useFormRoot();
    const { addToast } = useToastService();
    const navigate = useNavigate();
    const parsedFormData = useMemo(() => filespaceRenameFormParser.safeParse(formData), [formData]);
    const onError = (err) => {
        if (err instanceof BadRequestError) {
            injectErrors(transformServerErrorsToInjectableErrors(err.errors));
        }
        else {
            addToast({
                kind: 'negative',
                content: {
                    message: translate('Renaming failed. Please try again.'),
                },
                'data-testid': 'filespace-rename-error',
            });
        }
        closeModal();
    };
    const onSuccess = () => {
        void navigate(workspaceRoutes.workspace(filespace.workspaceId));
        addToast({
            kind: 'positive',
            content: {
                message: translate('Filespace renamed successfully.'),
            },
            'data-testid': 'filespace-rename-success',
        });
    };
    const { mutation: { isPending, isSuccess, mutate: renameFilespace }, } = useFilespaceRename({ filespaceId: filespace.id, workspaceId: filespace.workspaceId }, { onSuccess, onError });
    const onEditConfirm = useCallback(() => {
        openModal({
            content: (_jsx(FilespaceRenameAcknowledge, { filespace: filespace, onCancel: () => {
                    closeModal();
                }, onConfirm: () => {
                    if (parsedFormData.success) {
                        renameFilespace(parsedFormData.data);
                    }
                } })),
        });
    }, [
        renameFilespace,
        openModal,
        parsedFormData.success,
        parsedFormData.data,
        filespace,
        closeModal,
    ]);
    return (_jsx(InlineForm, { cancelAriaLabel: translate('cancel'), "data-testid": "filespace-name", disabled: !filespace.canRename, formElement: (labelProps) => (_jsx(TextInputField, { ...labelProps, autoFocus: true, clientErrorMessage: translate('Enter a valid filespace name.'), "data-testid": "filespace-name", id: "name", initialValue: filespace.name, name: "name", rules: filespaceNameValidationRules(), validator: filespaceNameValidator })), inputId: 'name', isLoading: isPending, isSaveAllowed: formData.name !== filespace.name &&
            parsedFormData.success &&
            !isPending, isSuccess: isSuccess, label: translate('Filespace name'), onSave: onEditConfirm, saveAriaLabel: translate('save'), value: filespace.name, valueClassName: PII_MASK_CLASS }));
};
_react_refresh_temp_1 = FilespaceRenameForm;
$RefreshReg$(_react_refresh_temp_1, "FilespaceRenameForm");
_react_refresh_temp_2(FilespaceRenameForm, "6EGvOa226ojVyAbvy+zzNxc6aCI=", false, () => [useModal, useFormRoot, useToastService, useNavigate, useFilespaceRename]);
